import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {RootCategoryShape} from 'utils/propTypes';
import {fetchCategories, getSelectedIds} from 'ducks/categories';

import RootCategory from './RootCategory';


class CategoryList extends React.Component {
    static propTypes = {
        onFetchCategories: PropTypes.func.isRequired,
        categories: PropTypes.arrayOf(RootCategoryShape),
    };

    static defaultProps = {
        categories: [],
        selected: null,
    };

    componentDidMount() {
        this.props.onFetchCategories();
    }

    renderRootCategory = category => (
        <RootCategory
            key={`root-${category.id}`}
            {...category}
        />
    );

    render() {
        const {categories} = this.props;

        if (!categories.length) {
            return null;
        }

        return (
            <ul className="category--items">
                {categories.map(this.renderRootCategory)}
            </ul>
        );
    }
}

// Map category with extra data from state
const mapCategorySelected = state => (category) => {
    const selectedCategories = getSelectedIds(state.selected, category.children);
    if (selectedCategories.length || category.id === state.selected) {
        selectedCategories.unshift(category.id);
    }
    return {
        selectedCategories,
        ...category,
    };
};

const mapStateToProps = ({categories}) => ({
    categories: categories.data.map(mapCategorySelected(categories)),
    selected: categories.selected,
});

const mapDispatchToProps = dispatch => ({
    onFetchCategories: () => dispatch(fetchCategories()),
});

const CategoryListConnector = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CategoryList);

export default CategoryListConnector;



// WEBPACK FOOTER //
// ./src/components/category_list/index.js